import useMetricUsageReport from '../../../../../hooks/useMetricUsageReport';
import { useMemo } from 'react';

const usePerformanceConfigurationDependencies = (
  metric?: Metrics.NormalMetric | Metrics.CompoundMetric,
) => {
  const usageReport = useMetricUsageReport(metric);
  const usedBy = useMemo(
    () => (usageReport ? usageReport.performanceConfigurations : []),
    [usageReport],
  );

  return {
    usageCount: usedBy.length,
    isUsedInPerformanceConfig: usedBy.length > 0,
    usedBy,
  };
};

export default usePerformanceConfigurationDependencies;
